import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DataViewModule } from 'primeng/dataview';
import { DividerModule } from 'primeng/divider';
import { DialogModule } from 'primeng/dialog';
import { CurrencyPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FloatLabelModule } from 'primeng/floatlabel';
import { NgxAimMembershipOverviewClass } from './ngx-aim-membership-checkout-overview.class';

@Component({
  selector: 'ngx-aim-membership-checkout-overview',
  standalone: true,
  imports: [
    ButtonModule,
    DataViewModule,
    DividerModule,
    DialogModule,
    CurrencyPipe,
    FormsModule,
    CheckboxModule,
    InputTextareaModule,
    FloatLabelModule,
  ],
  templateUrl: './ngx-aim-membership-checkout-overview.component.html',
  styleUrl: './ngx-aim-membership-checkout-overview.component.css'
})
export class NgxAimMembershipCheckoutOverviewComponent extends NgxAimMembershipOverviewClass implements OnInit {
  ngOnInit() {
    this.init();
  }
}
